import { useState } from "react";
import $ from "jquery";
import "./Header.scss";
import MobileMenu from "../../Components/Menu/Mobile/Menu";
import DeskTopMenu from "../../Components/Menu/Desktop/Menu";
import iconPathURL from "../../Common/iconPath";
const iconPath = process.env.PUBLIC_URL + "/assets/images/";

export default function Header(props) {
  const [showMobileLinks, setShowMobileLinks] = useState(false);
  const [count, setCount] = useState(0);

  const toggleMenu = () => {
    setCount(count + 1);
    if (showMobileLinks) {
      $(".mobile-links").slideUp("slow");
    } else {
      $(".mobile-links").slideDown("slow");
    }
    setShowMobileLinks(!showMobileLinks);
  };

  const toggle = () => {
    $(".mobile-links").slideUp("slow");
    setShowMobileLinks(!showMobileLinks);
  };

  return (
    <div>
      <div className="header">
        <div className="site-header-inner">
          <div className="row mobile-menu mobile-content">
            <div className="col-8 col-sm-3 col-md-3 col-lg-4 logo-container">
              <a className="logo-link primary-link" href="#/">
                <img
                  src={`${iconPath}logo/logo.png`}
                  className="logo"
                  alt="logo"
                />
              </a>
            </div>
            <div className="col-4 col-sm-9 col-md-8 menu-toggle-container">
              {count === 0 ? (
                <>
                  <img
                    style={{ height: 16, width: 16 }}
                    src={iconPathURL("common/menu.png")}
                    alt="menu icon"
                  />
                  <button className="toggle-first" onClick={toggleMenu}>
                    Menu
                  </button>
                </>
              ) : (
                <>
                  <img
                    style={{ height: 16, width: 16 }}
                    src={iconPathURL("common/menu_blue.png")}
                    alt="menu icon blue"
                  />
                  <a
                    className="primary-link"
                    onClick={toggleMenu}
                    style={{ cursor: "pointer" }}
                  >
                    <span>{!showMobileLinks ? "Menu" : "Close"}</span>
                  </a>
                </>
              )}
            </div>
          </div>
          <div className="desktop-menu">
            <div className="logo-container">
              <a className="logo-link primary-link" href="#/">
                <img
                  src={`${iconPath}logo/logo.png`}
                  alt="logo"
                  className="logo"
                />
              </a>
            </div>
            <div className="dektop-menu-list">
              <DeskTopMenu showMenu={props.showMenus}></DeskTopMenu>
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-links">
        <MobileMenu toggle={toggle}></MobileMenu>
      </div>
    </div>
  );
}
